import { defineMessages } from 'react-intl';

const messages = defineMessages({
    apiVersionIncompatibleHeader: {
        id: 'UpgradeScreen.apiVersionIncompatibleHeader',
        defaultMessage: 'hol\'s app Update Available',
    },
    apiVersionIncompatibleBody: {
        id: 'UpgradeScreen.apiVersionIncompatibleBody',
        // eslint-disable-next-line max-len
        defaultMessage: 'There is a newer version of hol\'s app available. To use hol\'s app please install the latest version.',
    },
    apiVersionIncompatibleBodyBrowser: {
        id: 'UpgradeScreen.apiVersionIncompatibleBodyBrowser',
        defaultMessage: 'There is a newer version of hol\'s app available. To use hol\'s app please reload the page.',
    },
    getUpdate: {
        id: 'UpgradeScreen.getUpdate',
        defaultMessage: 'Get Update',
    },
    reload: {
        id: 'UpgradeScreen.reload',
        defaultMessage: 'Reload',
    },
});

export default messages;
